import {UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {Grid, Typography} from "@mui/material";
import {Frame} from "../base/Frame";
import {CheckboxInput} from "../base/CheckboxInput";

export interface UserEmailPreferencesFormInputs {
    enabledMarketingEmails: boolean;
    enabledFieldAlerts: boolean;
}

export interface Props {
    initFormValues: UserEmailPreferencesFormInputs;
    form: UseFormReturn<UserEmailPreferencesFormInputs>;
}

export const UserEmailPreferencesForm: React.FC<Props> = ({initFormValues, form: {control}}) => {
    const {t} = useTranslation();

    return (
        <Frame>
            <Typography fontSize={16} textTransform="uppercase" sx={{marginBottom: "1rem"}}>
                {t("users.email_preferences_form.title")}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CheckboxInput
                        name="enabledFieldAlerts"
                        control={control}
                        initialValue={initFormValues.enabledFieldAlerts}
                        label={t("users.email_preferences_form.field_alert")}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CheckboxInput
                        name="enabledMarketingEmails"
                        control={control}
                        initialValue={initFormValues.enabledMarketingEmails}
                        label={t("users.email_preferences_form.marketing")}
                    />
                </Grid>
            </Grid>
        </Frame>
    );
};
